import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=0b4daa63&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=0b4daa63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4daa63",
  null
  
)

export default component.exports